import type { ApplicationAnswerRow } from '@/hooks/use-my-applications'
import type {
  ApplicationAnswerValue,
  ScreeningQuestion,
} from '@/components/candidate/candidate-featured-jobs-types'

/** Map stored draft answers into the apply-canvas field values. */
export function answersFromDraftRows(
  rows: ApplicationAnswerRow[] | undefined,
  questions: ScreeningQuestion[],
): Record<string, ApplicationAnswerValue> {
  const byId = new Map(questions.map((question) => [question.id, question]))
  const next: Record<string, ApplicationAnswerValue> = {}
  for (const row of rows ?? []) {
    const question = byId.get(row.question_id)
    if (!question) continue
    if (question.question_type === 'boolean') {
      if (row.answer_text === 'true') next[row.question_id] = true
      else if (row.answer_text === 'false') next[row.question_id] = false
    } else if (question.question_type === 'number') {
      const parsed = Number.parseInt(row.answer_text, 10)
      if (!Number.isNaN(parsed)) next[row.question_id] = parsed
    } else if (
      question.question_type === 'multiple_choice' ||
      question.question_type === 'multi_choice'
    ) {
      next[row.question_id] = Array.isArray(row.answer_options) ? row.answer_options : []
    } else {
      next[row.question_id] = row.answer_text || ''
    }
  }
  return next
}
